/** Interceptor <a href="/..."> -> navigasi SPA.
 *  Alasan: halaman hasil port memakai <a href="/a/..."> di banyak tempat (sidebar, chip filter,
 *  "Kelola Sync"). Tanpa ini setiap klik = full reload dan keunggulan SPA hilang.
 *  Link eksternal, target=_blank, download, /api/*, dan /healthz SENGAJA dibiarkan ke browser
 *  (export Excel dan proxy aset PDF harus tetap unduhan sungguhan). */
export function installSpaLinkInterceptor(navigate: (href: string) => void) {
  const onClick = (ev: MouseEvent) => {
    if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    const a = (ev.target as HTMLElement | null)?.closest?.("a");
    if (!a) return;
    const href = a.getAttribute("href");
    if (!href || !href.startsWith("/")) return;
    if (a.target && a.target !== "_self") return;
    if (a.hasAttribute("download")) return;
    if (href.startsWith("/api/") || href.startsWith("/healthz")) return;
    ev.preventDefault();
    navigate(href);
  };
  document.addEventListener("click", onClick);
  return () => document.removeEventListener("click", onClick);
}
